

export const incomeData = {
    'A': [
        {
            name: '收入',
            type: 'bar',
            data: [
                {
                    name: 2021,
                    value: 1356.082,
                    unit: '百万',
                },
                {
                    name: 2022,
                    value: 1561.317,
                    unit: '百万'
                },
                {
                    name: 2023,
                    value: 1759.641,
                    unit: '百万'
                },
                {
                    name: 2024,
                    value: 2060.767,
                    unit: '百万'
                }
            ]
        },
        {
            name: '同比',
            type: 'line',
            yAxisIndex: 1,
            data: [
                {
                    name: 2021,
                    value: '-'
                },
                {
                    name: 2022,
                    value: 15.1,
                    unit: '%'
                },
                {
                    name: 2023,
                    value: 12.7,
                    unit: '%'
                },
                {
                    name: 2024,
                    value: 17.1,
                    unit: '%'
                }
            ]
        }
    ],
    'H1': [
        {
            name: '收入',
            type: 'bar',
            data: [
                {
                    name: '2022H1',
                    value: 746.622,
                    unit: '百万'
                },
                {
                    name: '2022H2',
                    value: 814.695,
                    unit: '百万'
                },
                {
                    name: '2023H1',
                    value: 831.156,
                    unit: '百万'
                },
                {
                    name: '2023H2',
                    value: 928.485,
                    unit: '百万'
                },
                {
                    name: '2024H1',
                    value: 976.396,
                    unit: '百万'
                },
                {
                    name: '2024H2',
                    value: 1084.371,
                    unit: '百万'
                },
                {
                    name: '2025H1',
                    value: 1084.236,
                    unit: '百万'
                }
            ]
        },
        {
            name: '同比',
            type: 'line',
            yAxisIndex: 1,
            data: [
                {
                    name: '2022H1',
                    value: '-'
                },
                {
                    name: '2022H2',
                    value: '-'
                },
                {
                    name: '2023H1',
                    value: 11.3,
                    unit: '%'
                },
                {
                    name: '2023H2',
                    value: 14.0,
                    unit: '%'
                },
                {
                    name: '2024H1',
                    value: 17.5,
                    unit: '%'
                },
                {
                    name: '2024H2',
                    value: 16.8,
                    unit: '%'
                },
                {
                    name: '2025H1',
                    value: 11.0,
                    unit: '%'
                }
            ]
        }
    ]
}

export const grossProfitData = {
    'A': [
        {
            name: '毛利',
            type: 'bar',
            data: [
                {
                    name: 2021,
                    value: 460.159,
                    unit: '百万'
                },
                {
                    name: 2022,
                    value: 537.87,
                    unit: '百万'
                },
                {
                    name: 2023,
                    value: 658.134,
                    unit: '百万'
                },
                {
                    name: 2024,
                    value: 795.1,
                    unit: '百万'
                },
            ]
        },
        {
            name: '同比',
            type: 'line',
            yAxisIndex: 1,
            data: [
                {
                    name: 2021,
                    value: '-'
                },
                {
                    name: 2022,
                    value: 16.9,
                    unit: '%'
                },
                {
                    name: 2023,
                    value: 22.4,
                    unit: '%'
                },
                {
                    name: 2024,
                    value: 20.8,
                    unit: '%'
                }
            ]
        }
    ],
    'H1': [
        {
            name: '毛利',
            type: 'bar',
            data: [
                {
                    name: '2022H1',
                    value: 249.779,
                    unit: '百万'
                },
                {
                    name: '2022H2',
                    value: 288.091,
                    unit: '百万'
                },
                {
                    name: '2023H1',
                    value: 309.649,
                    unit: '百万'
                },
                {
                    name: '2023H2',
                    value: 348.485,
                    unit: '百万'
                },
                {
                    name: '2024H1',
                    value: 382.354,
                    unit: '百万'
                },
                {
                    name: '2024H2',
                    value: 412.746,
                    unit: '百万'
                },
                {
                    name: '2025H1',
                    value: 444.28,
                    unit: '百万'
                },
            ]
        },
        {
            name: '同比',
            type: 'line',
            yAxisIndex: 1,
            data: [
                {
                    name: '2022H1',
                    value: '-'
                },
                {
                    name: '2022H2',
                    value: '-'
                },
                {
                    name: '2023H1',
                    value: 24.0,
                    unit: '%'
                },
                {
                    name: '2023H2',
                    value: 21.0,
                    unit: '%'
                },
                {
                    name: '2024H1',
                    value: 23.5,
                    unit: '%'
                },
                {
                    name: '2024H2',
                    value: 18.4,
                    unit: '%'
                },
                {
                    name: '2025H1',
                    value: 16.2,
                    unit: '%'
                }
            ]
        }
    ]
}

export const grossMarginData = {
    'A': [
        {
            name: '毛利率',
            type: 'line',
            data: [
                {
                    name: 2021,
                    value: 33.9,
                    unit: '%'
                },
                {
                    name: 2022,
                    value: 34.4,
                    unit: '%'
                },
                {
                    name: 2023,
                    value: 37.4,
                    unit: '%'
                },
                {
                    name: 2024,
                    value: 38.6,
                    unit: '%'
                },
            ]
        }
    ],
    'H1': [
        {
            name: '毛利率',
            type: 'line',
            data: [
                {
                    name: '2022H1',
                    value: 33.5,
                    unit: '%'
                },
                {
                    name: '2022H2',
                    value: 35.4,
                    unit: '%'
                },
                {
                    name: '2023H1',
                    value: 37.3,
                    unit: '%'
                },
                {
                    name: '2023H2',
                    value: 37.5,
                    unit: '%'
                },
                {
                    name: '2024H1',
                    value: 39.2,
                    unit: '%'
                },
                {
                    name: '2024H2',
                    value: 38.1,
                    unit: '%'
                },
                {
                    name: '2025H1',
                    value: 41,
                    unit: '%'
                },
            ]
        }
    ]
}


export const coreOperatingProfitData = {
    'A': [
        {
            name: '核心经营利润',
            type: 'bar',
            data: [
                {
                    name: 2021,
                    value: 238.149,
                    unit: '百万'
                },
                {
                    name: 2022,
                    value: 313.156,
                    unit: '百万'
                },
                {
                    name: 2023,
                    value: 379.969,
                    unit: '百万'
                },
                {
                    name: 2024,
                    value: 471.321,
                    unit: '百万'
                },
            ]
        },
        {
            name: '同比',
            type: 'line',
            yAxisIndex: 1,
            data: [
                {
                    name: 2021,
                    value: '-'
                },
                {
                    name: 2022,
                    value: 31.5,
                    unit: '%'
                },
                {
                    name: 2023,
                    value: 21.3,
                    unit: '%'
                },
                {
                    name: 2024,
                    value: 24.0,
                    unit: '%'
                }
            ]
        }
    ],
    'H1': [
        {
            name: '核心经营利润',
            type: 'bar',
            data: [
                {
                    name: '2022H1',
                    value: 150.586,
                    unit: '百万'
                },
                {
                    name: '2022H2',
                    value: 162.57,
                    unit: '百万'
                },
                {
                    name: '2023H1',
                    value: 191.931,
                    unit: '百万'
                },
                {
                    name: '2023H2',
                    value: 188.038,
                    unit: '百万'
                },
                {
                    name: '2024H1',
                    value: 233.83,
                    unit: '百万'
                },
                {
                    name: '2024H2',
                    value: 237.491,
                    unit: '百万'
                },
                {
                    name: '2025H1',
                    value: 296.788,
                    unit: '百万'
                },
            ]
        },
        {
            name: '同比',
            type: 'line',
            yAxisIndex: 1,
            data: [
                {
                    name: '2022H1',
                    value: '-'
                },
                {
                    name: '2022H2',
                    value: '-'
                },
                {
                    name: '2023H1',
                    value: 27.5,
                    unit: '%'
                },
                {
                    name: '2023H2',
                    value: 15.7,
                    unit: '%'
                },
                {
                    name: '2024H1',
                    value: 21.8,
                    unit: '%'
                },
                {
                    name: '2024H2',
                    value: 26.3,
                    unit: '%'
                },
                {
                    name: '2025H1',
                    value: 26.9,
                    unit: '%'
                }
            ]
        }
    ]
}


export const coreOperatingProfitRateData = {
    'A': [
        {
            name: '核心经营利润率',
            type: 'line',
            data: [
                {
                    name: 2021,
                    value: 17.6,
                    unit: '%'
                },
                {
                    name: 2022,
                    value: 20.1,
                    unit: '%'
                },
                {
                    name: 2023,
                    value: 21.6,
                    unit: '%'
                },
                {
                    name: 2024,
                    value: 22.9,
                    unit: '%'
                },
            ]
        }
    ],
    'H1': [
        {
            name: '核心经营利润率',
            type: 'line',
            data: [
                {
                    name: '2022H1',
                    value: 20.2,
                    unit: '%'
                },
                {
                    name: '2022H2',
                    value: 20.0,
                    unit: '%'
                },
                {
                    name: '2023H1',
                    value: 23.1,
                    unit: '%'
                },
                {
                    name: '2023H2',
                    value: 20.3,
                    unit: '%'
                },
                {
                    name: '2024H1',
                    value: 23.9,
                    unit: '%'
                },
                {
                    name: '2024H2',
                    value: 21.9,
                    unit: '%'
                },
                {
                    name: '2025H1',
                    value: 27.4,
                    unit: '%'
                },
            ]
        }
    ]
}


export const ShareholdersNetProfitData = {
    'A': [
        {
            name: '归属股东净利润',
            type: 'bar',
            data: [
                {
                    name: 2021,
                    value: 183.522,
                    unit: '百万'
                },
                {
                    name: 2022,
                    value: 248.566,
                    unit: '百万'
                },
                {
                    name: 2023,
                    value: 327.022,
                    unit: '百万'
                },
                {
                    name: 2024,
                    value: 428.284,
                    unit: '百万'
                },
            ]
        },
        {
            name: '同比',
            type: 'line',
            yAxisIndex: 1,
            data: [
                {
                    name: 2021,
                    value: '-'
                },
                {
                    name: 2022,
                    value: 35.4,
                    unit: '%'
                },
                {
                    name: 2023,
                    value: 31.6,
                    unit: '%'
                },
                {
                    name: 2024,
                    value: 31.0,
                    unit: '%'
                }
            ]
        }
    ],
    'H1': [
        {
            name: '归属股东净利润',
            type: 'bar',
            data: [
                {
                    name: '2022H1',
                    value: 118.104,
                    unit: '百万'
                },
                {
                    name: '2022H2',
                    value: 130.462,
                    unit: '百万'
                },
                {
                    name: '2023H1',
                    value: 158.576,
                    unit: '百万'
                },
                {
                    name: '2023H2',
                    value: 168.446,
                    unit: '百万'
                },
                {
                    name: '2024H1',
                    value: 208.732,
                    unit: '百万'
                },
                {
                    name: '2024H2',
                    value: 219.552,
                    unit: '百万'
                },
                {
                    name: '2025H1',
                    value: 272.865,
                    unit: '百万'
                },
            ]
        },
        {
            name: '同比',
            type: 'line',
            yAxisIndex: 1,
            data: [
                {
                    name: '2022H1',
                    value: '-'
                },
                {
                    name: '2022H2',
                    value: '-'
                },
                {
                    name: '2023H1',
                    value: 34.3,
                    unit: '%'
                },
                {
                    name: '2023H2',
                    value: 29.1,
                    unit: '%'
                },
                {
                    name: '2024H1',
                    value: 31.6,
                    unit: '%'
                },
                {
                    name: '2024H2',
                    value: 30.3,
                    unit: '%'
                },
                {
                    name: '2025H1',
                    value: 30.7,
                    unit: '%'
                }
            ]
        }
    ]
}


export const netMarginData = {
    'A': [
        {
            name: '净利润率',
            type: 'line',
            data: [
                {
                    name: 2021,
                    value: 13.5,
                    unit: '%'
                },
                {
                    name: 2022,
                    value: 15.9,
                    unit: '%'
                },
                {
                    name: 2023,
                    value: 18.6,
                    unit: '%'
                },
                {
                    name: 2024,
                    value: 20.8,
                    unit: '%'
                },
            ]
        }
    ],
    'H1': [
        {
            name: '净利润率',
            type: 'line',
            data: [
                {
                    name: '2022H1',
                    value: 15.8,
                    unit: '%'
                },
                {
                    name: '2022H2',
                    value: 16,
                    unit: '%'
                },
                {
                    name: '2023H1',
                    value: 19.1,
                    unit: '%'
                },
                {
                    name: '2023H2',
                    value: 18.1,
                    unit: '%'
                },
                {
                    name: '2024H1',
                    value: 21.4,
                    unit: '%'
                },
                {
                    name: '2024H2',
                    value: 20.2,
                    unit: '%'
                },
                {
                    name: '2025H1',
                    value: 25.2,
                    unit: '%'
                },
            ]
        }
    ]
}


export const netCashData = {
    'A': [
        {
            name: '净(债务)现金',
            type: 'bar',
            data: [
                {
                    name: 2021,
                    value: -8.211,
                    unit: '百万'
                },
                {
                    name: 2022,
                    value: -18.560,
                    unit: '百万'
                },
                {
                    name: 2023,
                    value: 123.899,
                    unit: '百万'
                },
                {
                    name: 2024,
                    value: 259.899,
                    unit: '百万'
                }
            ]
        }
    ],
    'H1': [
        {
            name: '净(债务)现金',
            type: 'bar',
            data: [
                {
                    name: '2022H1',
                    value: -28.926,
                    unit: '百万'
                },
                {
                    name: '2022H2',
                    value: -18.560,
                    unit: '百万'
                },
                {
                    name: '2023H1',
                    value: 168.758,
                    unit: '百万'
                },
                {
                    name: '2023H2',
                    value: 123.899,
                    unit: '百万'
                },
                {
                    name: '2024H1',
                    value: 330.616,
                    unit: '百万'
                },
                {
                    name: '2024H2',
                    value: 259.899,
                    unit: '百万'
                },
                {
                    name: '2025H1',
                    value: 632.575,
                    unit: '百万'
                },
            ]
        }
    ]
}


export const cashDividendsData = {
    'A': [
        {
            name: '现金股息',
            type: 'bar',
            data: [
                {
                    name: 2022,
                    value: 63.99,
                    unit: '百万'
                },
                {
                    name: 2023,
                    value: 85.32,
                    unit: '百万'
                },
                {
                    name: 2024,
                    value: 128.5,
                    unit: '百万'
                },
            ]
        }
    ],
    'H1': [
        {
            name: '现金股息',
            type: 'bar',
            data: []
        }
    ]
}


export const dividendPayoutRatioData = {
    'A': [
        {
            name: '股息支付率',
            type: 'line',
            data: [
                {
                    name: 2022,
                    value: 25.7,
                    unit: '%'
                },
                {
                    name: 2023,
                    value: 26.1,
                    unit: '%'
                },
                {
                    name: 2024,
                    value: 30.0,
                    unit: '%'
                },
            ]
        }
    ],
    'H1': [
        {
            name: '股息支付率',
            type: 'line',
            data: []
        }
    ]
}


export const roaData = {
    'A': [
        {
            name: '资产回报率',
            type: 'line',
            data: [
                {
                    name: 2022,
                    value: 13.8,
                    unit: '%'
                },
                {
                    name: 2023,
                    value: 17.3,
                    unit: '%'
                },
                {
                    name: 2024,
                    value: 19.6,
                    unit: '%'
                },
            ]
        }
    ],
    'H1': [
        {
            name: '资产回报率',
            type: 'line',
            data: [
                {
                    name: '2022H1',
                    value: 13.7,
                    unit: '%'
                },
                {
                    name: '2022H2',
                    value: 14.9,
                    unit: '%'
                },
                {
                    name: '2023H1',
                    value: 17.4,
                    unit: '%'
                },
                {
                    name: '2023H2',
                    value: 17.5,
                    unit: '%'
                },
                {
                    name: '2024H1',
                    value: 20.1,
                    unit: '%'
                },
                {
                    name: '2024H2',
                    value: 19.2,
                    unit: '%'
                },
                {
                    name: '2025H1',
                    value: 19.4,
                    unit: '%'
                },
            ]
        }
    ]
}


export const roeData = {
    'A': [
        {
            name: '净资产收益率',
            type: 'line',
            data: [
                {
                    name: 2022,
                    value: 23.9,
                    unit: '%'
                },
                {
                    name: 2023,
                    value: 25.7,
                    unit: '%'
                },
                {
                    name: 2024,
                    value: 28.7,
                    unit: '%'
                },
            ]
        }
    ],
    'H1': [
        {
            name: '净资产收益率',
            type: 'line',
            data: [
                {
                    name: '2022H1',
                    value: 23.4,
                    unit: '%'
                },
                {
                    name: '2022H2',
                    value: 24.2,
                    unit: '%'
                },
                {
                    name: '2023H1',
                    value: 26.6,
                    unit: '%'
                },
                {
                    name: '2023H2',
                    value: 25.6,
                    unit: '%'
                },
                {
                    name: '2024H1',
                    value: 29.3,
                    unit: '%'
                },
                {
                    name: '2024H2',
                    value: 28.8,
                    unit: '%'
                },
                {
                    name: '2025H1',
                    value: 26.6,
                    unit: '%'
                },
            ]
        }
    ]
}